/**
 * Customer API returns this in `response.data.error` when the subscription
 * allows only one business profile. Must stay in sync with the API.
 */
export const BUSINESS_PROFILE_SUBSCRIPTION_LIMIT_ERROR =
  "You have already created a business profile for this subscription. Upgrade to create more profiles.";

export function isBusinessProfileSubscriptionLimitPayload(
  data: unknown
): boolean {
  if (!data || typeof data !== "object") return false;
  const err = (data as { error?: unknown }).error;
  return typeof err === "string" && err === BUSINESS_PROFILE_SUBSCRIPTION_LIMIT_ERROR;
}

/** Axios error shape from the default instance. */
export function isAxiosBusinessProfileSubscriptionLimitError(
  error: unknown
): boolean {
  const e = error as { response?: { data?: unknown } };
  return isBusinessProfileSubscriptionLimitPayload(e.response?.data);
}
